module.exports = __webpack_public_path__ + "img/20190730164453QQ截图20190730020044.6017d881.png";